import { Component, OnInit } from '@angular/core';
import {Localiser} from '../../services/localiser';
import {Navigation} from '../../services/navigation.service';
import {DeviceService} from "../../services/device.service";

@Component({
  selector: 'app-home-configuration',
  templateUrl: './home-configuration.component.html',
  styleUrls: ['./home-configuration.component.css']
})
export class HomeConfigurationComponent implements OnInit {

  constructor(public localiser: Localiser, private navigation: Navigation,
              private deviceService: DeviceService) { }

  ngOnInit(): void {
  }

  toDevices() {
    this.deviceService.nothingSelect();
    this.navigation.toDevices();
  }

  toUsers() {
    this.navigation.toUsers();
  }

  toReglas() {
    this.navigation.toReglas();
  }

  toLimits() {
    this.navigation.toLimits();
  }

  toAlerts() {
    this.navigation.toAlerts();
  }

  toFade() {
    this.navigation.toFade();
  }

  toOta() {
    this.navigation.toOta();
  }

  toParameters() {
    this.navigation.toParameters();
  }

}
